<template>
  <div>
    <form @submit.prevent="submit">
      <div class="flex justify-center px-5">
        <div class="feedback-board">
          <div class="bg-white rounded-lg p-5 sm:p-8">
            <h3 class="mb-5 text-xl text-left font-black">意見回饋</h3>
            <div class="space-y-3">
              <div>
                <!-- 姓名 -->
                <input
                  type="text"
                  id="name"
                  name="name"
                  class="bg-gray-100 p-2 rounded-md w-full"
                  placeholder="姓名"
                  v-model="feedbackData.name"
                />
              </div>
              <div>
                <!-- 電子信箱 -->
                <input
                  type="email"
                  id="email"
                  name="email"
                  class="bg-gray-100 p-2 rounded-md w-full"
                  placeholder="電子信箱(必填)"
                  v-model="feedbackData.email"
                  required
                />
              </div>
              <div>
                <!-- 職稱 -->
                <input
                  type="text"
                  id="title"
                  name="title"
                  class="bg-gray-100 p-2 rounded-md w-full"
                  placeholder="單位/職稱"
                  v-model="feedbackData.title"
                />
              </div>
              <div class="bg-gray-100 p-2 rounded-md w-full">
              <!-- 類別 -->
              <select
                id="sort"
                name="sort"
                class="bg-gray-100 w-full"
                v-model="feedbackData.feedback_type"
                required
              >
                <option value="" selected disabled>意見類別(必選)</option>
                <option value="鑑定錯誤">鑑定錯誤</option>
                <option value="學名拼字錯誤">學名拼字錯誤</option>
                <option value="採集資訊內容有誤">採集資訊內容有誤</option>
                <option value="其他錯誤或說明">其他錯誤或說明</option>
              </select>
              </div>
              <div>
                <!-- 意見 -->
                <textarea
                  type="text"
                  id="feedback_message"
                  name="feedback_message"
                  class="bg-gray-100 w-full p-2 rounded-md h-32"
                  maxlength="500"
                  placeholder="意見(必填)"
                  v-model="feedbackData.feedback_message"
                  required
                />
              </div>
            </div>
            <div class="flex justify-center space-x-5 pt-5">
              <div @click="close" class="cancel-button cursor-pointer">取消</div>
              <button type="submit" class="submit-button">送出</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { postFeedback } from "@/api/specimen"

export default {
  data() {
    return {
      feedbackData: {
        name: '',
        email: '',
        title: '',
        feedback_type: '',
        feedback_message: '',
        specimen_id: this.$route.params.id
      }
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      postFeedback(this.$route.params.id, this.feedbackData).then(
        (response) => {
          console.log('postFeedback success')
        },
        (error) => {
          console.log("err", error.response)
        })
      this.$emit("close");
    }
  }
}

</script>

<style scoped>
.feedback-board {
  width: 500px;
}

.web-bg-color {
  background-color: #64859D;
}

.web-dark-bg-color {
  background-color: #405d73;
}

.submit-button {
  @apply web-bg-color rounded px-5 py-2 text-white;
}

.submit-button:hover {
  @apply web-dark-bg-color rounded px-5 py-2 text-white;
}

.cancel-button {
  @apply bg-gray-300 rounded px-5 py-2;
}

.cancel-button:hover {
  @apply bg-gray-400 rounded px-5 py-2;
}
</style>
